import { useState } from "react";
import { Loader2, Mail, MessageCircle, Check } from "lucide-react";
import { toast } from "sonner";
import { Input } from "../ui/input";
import { api, apiError } from "../../lib/api";

const SeatShare = ({ code, t, seat, initial, trip }) => {
  const [f, setF] = useState({ name: initial?.name ?? "", email: "" });
  const [busy, setBusy] = useState("");
  const [sent, setSent] = useState(initial?.sent ?? false);
  const go = async (via) => {
    if (f.name.trim().length < 2) return toast.error("Escribí el nombre del acompañante");
    if (via === "email" && !f.email.includes("@")) return toast.error("Escribí su email");
    setBusy(via);
    const win = via === "wa" ? window.open("", "_blank") : null;
    try {
      const { data } = await api.post(`/tickets/${encodeURIComponent(code)}/share`, { seat, name: f.name, email: via === "email" ? f.email : null }, { params: { t } });
      const link = `${window.location.origin}${data.ticket_url}`;
      if (via === "wa") {
        const text = `Hola ${f.name.split(" ")[0]}, este es tu pasaje Santiagueño ${trip}, butaca ${seat}: ${link}`;
        if (win) win.location.href = `https://wa.me/?text=${encodeURIComponent(text)}`;
      } else { setSent(true); toast.success(`Pasaje enviado a ${f.email}`); }
    } catch (e) { win?.close(); toast.error(apiError(e)); } finally { setBusy(""); }
  };
  return (
    <div data-testid={`share-seat-${seat}`} className="rounded-2xl bg-white/10 p-4">
      <p className="text-sm font-bold text-white">Butaca {seat} {sent && <span className="ml-1 inline-flex items-center gap-1 rounded-full bg-[var(--lime)] px-2 py-0.5 text-[11px] text-[var(--ink)]"><Check className="h-3 w-3" /> enviado</span>}</p>
      <div className="mt-2 space-y-2">
        <Input data-testid={`share-name-${seat}`} placeholder="Nombre del acompañante" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} className="h-11 rounded-xl bg-white" />
        <Input data-testid={`share-email-${seat}`} type="email" placeholder="Email (para enviarlo por email)" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} className="h-11 rounded-xl bg-white" />
        <div className="grid grid-cols-2 gap-2">
          <button onClick={() => go("email")} disabled={Boolean(busy)} data-testid={`share-send-email-${seat}`} className="flex h-11 items-center justify-center gap-2 rounded-xl bg-[var(--lime)] text-sm font-bold text-[var(--ink)]">{busy === "email" ? <Loader2 className="h-4 w-4 animate-spin" /> : <Mail className="h-4 w-4" />} Email</button>
          <button onClick={() => go("wa")} disabled={Boolean(busy)} data-testid={`share-send-wa-${seat}`} className="flex h-11 items-center justify-center gap-2 rounded-xl bg-[#25D366] text-sm font-bold text-[var(--ink)]">{busy === "wa" ? <Loader2 className="h-4 w-4 animate-spin" /> : <MessageCircle className="h-4 w-4" />} WhatsApp</button>
        </div>
      </div>
    </div>
  );
};

export const CompanionShare = ({ b, code, t }) => {
  const others = (b.seats ?? []).slice(1);
  if (!others.length) return null;
  return (
    <div data-testid="companion-share" className="space-y-3 rounded-3xl bg-white/5 p-4 ring-1 ring-white/15">
      <p className="font-display-up text-lg text-white">Pasajes de tus acompañantes</p>
      <p className="text-sm text-white/80">Mandale a cada uno su butaca con su propio QR, así sube por su cuenta. Tu pasaje sigue sirviendo para todo el grupo.</p>
      {others.map((s) => <SeatShare key={s} code={code} t={t} seat={s} initial={b.companions?.[String(s)]} trip={`${b.origin} → ${b.destination} del ${b.date} ${b.departure} hs`} />)}
    </div>
  );
};
